/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function ChevronRightIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" {...props}>
            <path d="M7.74167 13.2333L10.975 9.99999L7.74167 6.76666C7.66452 6.68951 7.60332 6.59791 7.56157 6.49711C7.51981 6.39631 7.49832 6.28827 7.49832 6.17916C7.49832 6.07005 7.51981 5.96201 7.56157 5.86121C7.60332 5.7604 7.66452 5.66881 7.74167 5.59166C7.81882 5.51451 7.91042 5.45331 8.01122 5.41155C8.11202 5.3698 8.22006 5.34831 8.32917 5.34831C8.43828 5.34831 8.54632 5.3698 8.64712 5.41155C8.74793 5.45331 8.83952 5.51451 8.91667 5.59166L12.7417 9.41666C13.0667 9.74166 13.0667 10.2667 12.7417 10.5917L8.91667 14.4167C8.83958 14.4939 8.748 14.5552 8.64719 14.597C8.54638 14.6388 8.43831 14.6604 8.32917 14.6604C8.22003 14.6604 8.11196 14.6388 8.01115 14.597C7.91034 14.5552 7.81877 14.4939 7.74167 14.4167C7.42501 14.0917 7.41667 13.5583 7.74167 13.2333Z" />
        </svg>
    );
}
